import IconTypeMapper from '@/shared/mappings/icon-type-mapper';
import { IconTypes } from '@/shared/models/icon-types';
import { IHighlights } from '@/shared/models/interface/search-index-model';

import { ISearchResult, ISearchResults } from '../models/azure-search-model';
import { SearchResult, SearchResults } from '../models/search-viewmodel';

/**
 * Mapper for the Azure Search results to the SearchOverlay Results
 */
export default class AzureSearchMapper {
    public mapSearchResults(item: ISearchResults): SearchResults {
        let results: SearchResult[] = item.value ? item.value.map((result: ISearchResult) => this.mapSearchResult(result)) : [];

        return new SearchResults(
            item['@odata.count'],
            results
        );
    }

    private mapSearchResult(item: ISearchResult): SearchResult {
        let highlight: string = this.getHighlight(item['@search.highlights'], item.IntroText);
        let icon: IconTypes = IconTypeMapper.mapItem(item.IconType);
        
        return new SearchResult(
            item.Title,
            item.Url,
            icon,
            highlight,
            item.Categories            
        );
    }

    /**
     * Takes a list of highlighted sentences and the string of the original (not highlighted) text
     * @param highlights a list of highlighted sentences
     * @param fullString the full string without highlights
     * @returns a string where sentences are replaced by the highlighted sentence
     */
    private getHighlight(highlights: IHighlights, fullString: string): string {
        let highlightSentences = highlights && highlights.IntroText ? highlights.IntroText : [];

        highlightSentences.forEach(sentence => {
            let cleanSentence = sentence.replace(/<[^>]*>/g, '');
            fullString = fullString.replace(cleanSentence, sentence);
        })

        return fullString;
    }
}
